module.exports = __webpack_public_path__ + "img/1554866499.98b3ea51.jpg";